askSchoolSpecificQuestions.classy.controller({
    name: 'AskSchoolSpecificQuestionsController',
    inject: ['$scope', '$modal', '$sce', '$rootScope', 'authServiceFactory', 'HelpSystemModelService', 'AskSchoolSpecificQuestionsModelService'],
    init: function()
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.AskSchoolSpecificQuestionsModelService = this.AskSchoolSpecificQuestionsModelService;
        this.$rootScope.model = this.AskSchoolSpecificQuestionsModelService;
        this.$.HelpSystemModelService = this.HelpSystemModelService;  
        this.$.$sce = this.$sce;
        this.$.html = "<p>You may set questions that ask for information that is important to your school and/or process that are not asked by FAST. Simply click the 'add a question' link and follow the instructions to set a question up. All active questions will be asked on a page that explains your school has requested additional information.<help-button active='active[0]' help-msg='helpMsg[0]'></help-button></p>";
        //this.$.arrayCud = this.standardCudArrayFactory(this.$.AskSchoolSpecificQuestionsModelService, this.authServiceFactory.getAuth().schoolID, this.$.AskSchoolSpecificQuestionsModelService.data, this, []);

        var self = this;   
        this.$.sortableOptions = {
            stop: function(e, ui)
            {
                self.$.newOrder = [];
                $( ".questionrow" ).each(function( index ) {
                    self.$.newOrder[index] = $(this).attr("id");
                });
                for (let key in self.$.newOrder)
                {
                    for (let key2 in self.$.AskSchoolSpecificQuestionsModelService.data)
                    {
                        if (self.$.newOrder[key] == self.$.AskSchoolSpecificQuestionsModelService.data[key2].recordID)
                        {
                            self.$.AskSchoolSpecificQuestionsModelService.data[key2].questionOrder = parseInt(key) + 1;
                        }
                    }
                }
                self.$.$apply();
            }
        }
   },
   previewForm: function()
   {
      window.open(this.$.previewURL, 'so', 'toolbar=0,scrollbars=1,location=0,status=0,menubars=0,width=600,height=600');
   },
   inlineSave: function(index)
   {
      var parent = this;
      this.AskSchoolSpecificQuestionsModelService.put(this.$.authServiceFactory.auth.schoolID, this.$.AskSchoolSpecificQuestionsModelService.data[index]).then(function (response) {
          parent.AskSchoolSpecificQuestionsModelService.resolveData(); 
      });

   },
   submit: function(scope, instance, form)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.AskSchoolSpecificQuestionsModelService.put(this.id, this.$.AskSchoolSpecificQuestionsModelService.data, instance).then(function (response) {
                parent.AskSchoolSpecificQuestionsModelService.resolveData();
            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        if (typeof callback !== 'undefined')
            callback();  
    },
    SSQModal: function(index) 
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/askSchoolSpecificQuestions/partials/askSchoolSpecificQuestionsModal.html?v=" + versionNo,
            controller: "AskSchoolSpecificQuestionsModalController",
            resolve: {
                item: function(authServiceFactory, AskSchoolSpecificQuestionsModelService) {
                    if (index == undefined)
                      return AskSchoolSpecificQuestionsModelService.data[AskSchoolSpecificQuestionsModelService.new()]
                    else
                      return AskSchoolSpecificQuestionsModelService.data[index]
                },
                index: function() {
                  return index;
                }
            },
            backdrop: 'static',
            keyboard: false
        });
    },
    iframeModal: function()
    {
        return this.$modal.open({
            templateUrl: "fast/submodules/schoolside/settings/parentApp/askSchoolSpecificQuestions/partials/iframeModal.html?v=" + versionNo,
            controller: "iframeModalController"
        });
    }
});

